import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const NavButton = (props) => {
  let color = 'primary';
  switch (props.color) {
    case 'primary':
      color = 'primary';
      break;
    case 'secondary':
      color = 'secondary';
      break;
    default:
      break;
  }
  const buttonColor = 'button-' + color;
  return (
    <NavLink
      to={props.to ? props.to : ''}
      className={
        props.classes
          ? `button ${buttonColor} ` + props.classes
          : `button ${buttonColor}`
      }
      style={{ marginBottom: 10 }}
    >
      {props.children}
    </NavLink>
  );
};

export default NavButton;

NavButton.propTypes = {
  to: PropTypes.string,
  classes: PropTypes.string,
  children: PropTypes.node.isRequired,
};
